// extracted by css-extract-rspack-plugin
export default {"dropdown":"SHqDM"};